import { render, staticRenderFns } from "./Christmas.vue?vue&type=template&id=4b4ccff8&"
import script from "./Christmas.vue?vue&type=script&lang=js&"
export * from "./Christmas.vue?vue&type=script&lang=js&"
import style0 from "./Christmas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports